import { Action, action } from 'easy-peasy';

export interface SuggestStoreModel {
  isOpen: boolean;
  close: Action<SuggestStoreModel>;
  open: Action<SuggestStoreModel>;
  toggle: Action<SuggestStoreModel>;
}

const suggestStoreModel: SuggestStoreModel = {
  isOpen: false,
  close: action((s) => {
    s.isOpen = false;
  }),
  open: action((s) => {
    s.isOpen = true;
  }),
  toggle: action((s) => {
    s.isOpen = !s.isOpen;
  }),
};

export default suggestStoreModel;
